<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object as PropType<any>,
    default: () => { }
  }
})

const route = useRoute()
const lists = computed(() => {
  return props?.data?.data?.map((item: any) => {
    return {
      image: item?.image?.link,
      title: item.subject,
      category: item.categories.length > 0 ? item.categories[0].subject : '',
      date: item.publish_date,
      link: `/sustainability/article/${item?.seo?.meta_slug || item.id}`
    }
  })
})

const handleChangePage = (page: number) => {
  navigateTo({ path: route.path, query: { page: page } })
}

</script>

<template>
  <div>
    <ul class="lists">
      <li v-for="item in lists" :key="item.title">
        <CardCard11 :data="item" />
      </li>
    </ul>
    <div class="paginationBox">
      <Pagination2 class="h-pagination center" layout="prev, pager, next" :page-meta="data.meta"
        :handleChangePage="handleChangePage" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.lists {
  @include grid(9, 24);
  grid-template-columns: repeat(3, 1fr);

  @include max-media(767) {
    grid-template-columns: repeat(2, 1fr);
  }

  @include max-media(480) {
    grid-template-columns: repeat(1, 1fr);
  }

  li {
    margin-bottom: toRem(56);

    @include max-media(480) {
      margin-bottom: toRem(20);
    }
  }
}

.paginationBox {
  display: flex;
  justify-content: center;
  padding-top: toRem(24);
  padding-bottom: toRem(24);
}
</style>
